/**
 * Reads the joined columns a refused save would stop sending (ACT2-1097).
 *
 * The server refuses an edit of an audience already in RudderStack that drops a joined column, with a
 * CONFLICT carrying `data.removedJoinedColumns`: a destination that still maps one fails its whole sync.
 * The page asks the user, then retries with `confirmRemovedJoinedColumns`. Duck-typed like
 * `DeleteAccountDialog`'s reader — the client error is not always a real `ORPCError` instance.
 */
export function removedJoinedColumnsFrom(err: unknown): string[] | null {
  if (!err || typeof err !== 'object') return null;
  const e = err as { code?: unknown; data?: { removedJoinedColumns?: unknown } };
  if (e.code !== 'CONFLICT') return null;
  const removed = e.data?.removedJoinedColumns;
  if (!Array.isArray(removed)) return null;
  const names = removed.filter((name): name is string => typeof name === 'string');
  return names.length > 0 ? names : null;
}
